'use es6';

import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
export const requestDashboardAccess = dashboardId => http.post(`/dashboard/v2/dashboard/${dashboardId}/permission/request`).then(fromJS);